import IpsTheme from './IpsTheme.vue';

export default IpsTheme;
